var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loadingDetail
    ? _c(
        "div",
        { staticClass: "eu-pa_6 eu-align_center" },
        [_c("emd-loader", { attrs: { type: "_invert" } })],
        1
      )
    : _c(
        "div",
        [
          _c("div", { staticClass: "el-section" }, [
            _c("div", { staticClass: "el-grid-list" }, [
              _c("div", { staticClass: "emd-container" }, [
                _c("div", {
                  staticClass: "emd-status-bar",
                  class: _vm.statusClass(_vm.subscription.status),
                }),
                _c("div", { staticClass: "emd-container__content" }, [
                  _c("div", { staticClass: "el-chunk" }, [
                    _c(
                      "h4",
                      {
                        staticClass:
                          "emd-text _color_subtle _type_label _size_tiny",
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("subscription.info.status")) + " "
                        ),
                      ]
                    ),
                  ]),
                  _c(
                    "span",
                    {
                      staticClass: "emd-badge",
                      class: _vm.statusClass(_vm.subscription.status),
                    },
                    [_vm._v(_vm._s(_vm.subscription.status))]
                  ),
                ]),
              ]),
              _c("div", { staticClass: "emd-container" }, [
                _c("div", { staticClass: "emd-container__content" }, [
                  _c("div", { staticClass: "el-chunk" }, [
                    _c(
                      "h4",
                      {
                        staticClass:
                          "emd-text _color_subtle _type_label _size_tiny",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("subscription.info.interval")) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c("p", { staticClass: "emd-text _size_section" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("subscription.info.interval-each")) +
                        " " +
                        _vm._s(_vm.subscription.interval_count) +
                        " " +
                        _vm._s(
                          _vm.pluralIntervals(
                            _vm.subscription.interval_count,
                            _vm.subscription.interval
                          )
                        ) +
                        " "
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "emd-container" }, [
                _c("div", { staticClass: "emd-container__content" }, [
                  _c("div", { staticClass: "el-chunk" }, [
                    _c(
                      "h4",
                      {
                        staticClass:
                          "emd-text _color_subtle _type_label _size_tiny",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("subscription.info.payment-method")) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c("p", { staticClass: "emd-text _size_section" }, [
                    _vm._v(" " + _vm._s(_vm.subscription.payment_method) + " "),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "emd-container" }, [
                _c("div", { staticClass: "emd-container__content" }, [
                  _c("div", { staticClass: "el-chunk" }, [
                    _c(
                      "h4",
                      {
                        staticClass:
                          "emd-text _color_subtle _type_label _size_tiny",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("subscription.info.start-at")) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c("p", { staticClass: "emd-text _size_section" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("dateFormat")(
                            _vm.subscription.start_at,
                            "date"
                          )
                        ) +
                        " "
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "el-section" }, [
            _c("div", { staticClass: "emd-container _highlight_header" }, [
              _c("div", { staticClass: "emd-container__header" }, [
                _c("h2", { staticClass: "emd-text _size_section" }, [
                  _vm._v(" " + _vm._s(_vm.$t("subscription.info.title")) + " "),
                ]),
                _vm.showCancelButton &&
                _vm.permissionIsEnabled("subscription:cancel") &&
                _vm.componentIsEnabled("subscription", "cancel")
                  ? _c(
                      "button",
                      {
                        staticClass: "emd-btn _color_danger _size_small",
                        attrs: { type: "button" },
                        on: { click: _vm.openModal },
                      },
                      [
                        _c("i", { staticClass: "uil uil-times-circle" }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("subscription.info.cancel-subscription")
                            ) +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "emd-container__content" }, [
                _c("div", { staticClass: "emd-panel" }, [
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("subscription.info.general-data")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _type_label _color_subtle _size_tiny",
                          },
                          [_vm._v(" ID ")]
                        ),
                        _c("span", [
                          _vm._v(_vm._s(_vm.subscription.id || "-")),
                        ]),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _type_label _color_subtle _size_tiny",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("subscription.info.code")) +
                                " "
                            ),
                          ]
                        ),
                        _c("span", [
                          _vm._v(_vm._s(_vm.subscription.code || "-")),
                        ]),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _type_label _color_subtle _size_tiny",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("subscription.info.billing-type")
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("span", [
                          _vm._v(_vm._s(_vm.subscription.billing_type || "-")),
                        ]),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _type_label _color_subtle _size_tiny",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("subscription.info.currency")) +
                                " "
                            ),
                          ]
                        ),
                        _c("span", [
                          _vm._v(_vm._s(_vm.subscription.currency || "-")),
                        ]),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _type_label _color_subtle _size_tiny",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("subscription.info.next-billing")
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("dateFormat")(
                                _vm.subscription.next_billing_at,
                                "date"
                              )
                            )
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _type_label _color_subtle _size_tiny",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("subscription.info.installments")
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("span", [
                          _vm._v(_vm._s(_vm.subscription.installments || "-")),
                        ]),
                      ]),
                      _vm.subscription.created_at
                        ? _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "emd-text _type_label _color_subtle _size_tiny",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("subscription.info.created-at")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("dateFormat")(
                                    _vm.subscription.created_at,
                                    "dateAndHour"
                                  )
                                )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.subscription.updated_at
                        ? _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "emd-text _type_label _color_subtle _size_tiny",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("subscription.info.updated-at")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("dateFormat")(
                                    _vm.subscription.updated_at,
                                    "dateAndHour"
                                  )
                                )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.subscription.metadata &&
                      Object.entries(_vm.subscription.metadata).length
                        ? _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "emd-text _color_subtle _type_label _size_tiny",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("subscription.info.more-info")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("pre", [
                              _vm._v(_vm._s(_vm.subscription.metadata)),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "emd-panel" }, [
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("subscription.info.customer.title")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c(
                        "div",
                        { staticClass: "el-chunk" },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "emd-text _type_label _color_subtle _size_tiny",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("subscription.info.customer.name")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _vm.permissionIsEnabled("customer:get")
                            ? _c(
                                "router-link",
                                {
                                  staticClass: "emd-link",
                                  attrs: {
                                    to: {
                                      name: "customersDetail",
                                      params: {
                                        id: _vm.subscription.customer.id,
                                        tab: "info",
                                      },
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.subscription.customer.name || "-"
                                    )
                                  ),
                                ]
                              )
                            : _c("p", { staticClass: "emd-text" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.subscription.customer.name || "-"
                                    ) +
                                    " "
                                ),
                              ]),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _type_label _color_subtle _size_tiny",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("subscription.info.customer.email")
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.subscription.customer.email || "-")
                          ),
                        ]),
                      ]),
                      _vm.subscription.customer.phones &&
                      _vm.subscription.customer.phones.home_phone
                        ? _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "emd-text _type_label _color_subtle _size_tiny",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("subscription.info.customer.phone")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.subscription.customer.phones.home_phone
                                    .country_code
                                ) +
                                  " " +
                                  _vm._s(
                                    _vm.subscription.customer.phones.home_phone
                                      .area_code
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm.subscription.customer.phones.home_phone
                                      .number
                                  )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.subscription.customer.phones &&
                      _vm.subscription.customer.phones.mobile_phone
                        ? _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "emd-text _type_label _color_subtle _size_tiny",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "subscription.info.customer.mobile-phone"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.subscription.customer.phones.mobile_phone
                                    .country_code
                                ) +
                                  " " +
                                  _vm._s(
                                    _vm.subscription.customer.phones
                                      .mobile_phone.area_code
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm.subscription.customer.phones
                                      .mobile_phone.number
                                  )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
                _vm.subscription.plan
                  ? _c("div", { staticClass: "emd-panel" }, [
                      _c("div", { staticClass: "emd-panel__section" }, [
                        _c("div", { staticClass: "emd-panel__block" }, [
                          _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "emd-text _color_default _type_caption",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("subscription.info.plan.title")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "emd-panel__block" }, [
                          _c(
                            "div",
                            { staticClass: "el-chunk" },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "emd-text _type_label _color_subtle _size_tiny",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("subscription.info.plan.name")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _vm.permissionIsEnabled("plan:get")
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass: "emd-link",
                                      attrs: {
                                        to: {
                                          name: "plansDetail",
                                          params: {
                                            id: _vm.subscription.plan.id,
                                            tab: "info",
                                          },
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.subscription.plan.name || "-"
                                        )
                                      ),
                                    ]
                                  )
                                : _c("p", { staticClass: "emd-text" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.subscription.plan.name || "-"
                                        ) +
                                        " "
                                    ),
                                  ]),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "emd-text _type_label _color_subtle _size_tiny",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("subscription.info.plan.interval")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("subscription.info.plan.interval-each")
                                ) +
                                  " " +
                                  _vm._s(_vm.subscription.plan.interval_count) +
                                  " " +
                                  _vm._s(
                                    _vm.pluralIntervals(
                                      _vm.subscription.plan.interval_count,
                                      _vm.subscription.plan.interval
                                    )
                                  )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
          _vm.subscription.items.length
            ? _c("div", { staticClass: "el-section" }, [
                _c("div", { staticClass: "emd-container _highlight_header" }, [
                  _c("div", { staticClass: "emd-container__header" }, [
                    _c("h2", { staticClass: "emd-text _size_section" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("subscription.info.items.title")) +
                          " "
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "emd-table-responsive" }, [
                    _c("table", { staticClass: "emd-table" }, [
                      _c("thead", [
                        _c("tr", [
                          _c("th", [
                            _vm._v(
                              _vm._s(_vm.$t("subscription.info.items.name"))
                            ),
                          ]),
                          _c("th", [
                            _vm._v(
                              _vm._s(_vm.$t("subscription.info.items.status"))
                            ),
                          ]),
                          _c("th", [
                            _vm._v(
                              _vm._s(_vm.$t("subscription.info.items.quantity"))
                            ),
                          ]),
                          _c("th", [
                            _vm._v(
                              _vm._s(_vm.$t("subscription.info.items.scheme"))
                            ),
                          ]),
                          _c("th", [
                            _vm._v(
                              _vm._s(_vm.$t("subscription.info.items.amount"))
                            ),
                          ]),
                          _c("th", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("subscription.info.items.updated-at")
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _c(
                        "tbody",
                        _vm._l(_vm.subscription.items, function (item, index) {
                          return _c("tr", { key: index }, [
                            _c(
                              "td",
                              {
                                attrs: {
                                  "data-label": _vm.$t(
                                    "subscription.info.items.name"
                                  ),
                                },
                              },
                              [_vm._v(" " + _vm._s(item.name || "-") + " ")]
                            ),
                            _c(
                              "td",
                              {
                                attrs: {
                                  "data-label": _vm.$t(
                                    "subscription.info.items.status"
                                  ),
                                },
                              },
                              [_vm._v(" " + _vm._s(item.status || "-") + " ")]
                            ),
                            _c(
                              "td",
                              {
                                attrs: {
                                  "data-label": _vm.$t(
                                    "subscription.info.items.quantity"
                                  ),
                                },
                              },
                              [_vm._v(" " + _vm._s(item.quantity || "-") + " ")]
                            ),
                            _c(
                              "td",
                              {
                                attrs: {
                                  "data-label": _vm.$t(
                                    "subscription.info.items.scheme"
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.pricing_scheme.scheme_type || "-"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "td",
                              {
                                attrs: {
                                  "data-label": _vm.$t(
                                    "subscription.info.items.amount"
                                  ),
                                },
                              },
                              [
                                item.pricing_scheme.price_brackets.length
                                  ? _c(
                                      "div",
                                      [
                                        _vm._l(
                                          item.pricing_scheme.price_brackets,
                                          function (price, index) {
                                            return _c(
                                              "p",
                                              {
                                                key: index,
                                                staticClass: "eu-pb_2",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "subscription.info.items.interval-from"
                                                      )
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      price.start_quantity
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "subscription.info.items.interval-to"
                                                      )
                                                    ) +
                                                    " " +
                                                    _vm._s(price.end_quantity) +
                                                    " "
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "eu-mr_1 eu-ml_1 uil uil-arrow-right",
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "emd-text _type_caption",
                                                  },
                                                  [_vm._v(_vm._s(price.price))]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        _c("p", { staticClass: "eu-pb_2" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "subscription.info.items.interval-over"
                                                )
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm.lastPrice(
                                                  item.pricing_scheme
                                                    .price_brackets
                                                ).end_quantity
                                              ) +
                                              " "
                                          ),
                                          _c("i", {
                                            staticClass:
                                              "eu-mr_1 eu-ml_1 uil uil-arrow-right",
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "emd-text _type_caption",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.lastPrice(
                                                    item.pricing_scheme
                                                      .price_brackets
                                                  ).overage_price
                                                )
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      2
                                    )
                                  : _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            item.pricing_scheme.price || "-"
                                          ) +
                                          " "
                                      ),
                                    ]),
                              ]
                            ),
                            _c(
                              "td",
                              {
                                attrs: {
                                  "data-label": _vm.$t(
                                    "subscription.info.items.updated-at"
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("dateFormat")(
                                        item.updated_at,
                                        "dateAndHour"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ])
                        }),
                        0
                      ),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm.subscription.setup
            ? _c("div", { staticClass: "el-section" }, [
                _c("div", { staticClass: "emd-container _highlight_header" }, [
                  _c("div", { staticClass: "emd-container__header" }, [
                    _c("h2", { staticClass: "emd-text _size_section" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("subscription.info.setup.title")) +
                          " "
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "emd-container__content" }, [
                    _c("div", { staticClass: "emd-panel" }, [
                      _c("div", { staticClass: "emd-panel__section" }, [
                        _c("div", { staticClass: "emd-panel__block" }, [
                          _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "emd-text _color_default _type_caption",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("subscription.info.general-data")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "emd-panel__block" }, [
                          _c(
                            "div",
                            { staticClass: "el-chunk" },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "emd-text _type_label _color_subtle _size_tiny",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "subscription.info.setup.order-id"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _vm.permissionIsEnabled("order:get")
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass: "emd-link",
                                      attrs: {
                                        to: {
                                          name: "ordersDetail",
                                          params: {
                                            id: _vm.subscription.setup.id,
                                          },
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.subscription.setup.id || "-")
                                      ),
                                    ]
                                  )
                                : _c("p", { staticClass: "emd-text" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.subscription.setup.id || "-"
                                        ) +
                                        " "
                                    ),
                                  ]),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "emd-text _type_label _color_subtle _size_tiny",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("subscription.info.setup.amount")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.subscription.setup.amount || "-")
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "emd-text _type_label _color_subtle _size_tiny",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("subscription.info.setup.status")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "emd-badge",
                                class: _vm.statusClass(
                                  _vm.subscription.setup.status
                                ),
                              },
                              [_vm._v(_vm._s(_vm.subscription.setup.status))]
                            ),
                          ]),
                          _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "emd-text _type_label _color_subtle _size_tiny",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "subscription.info.setup.description"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.subscription.setup.description || "-"
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _c("log-links", {
            attrs: {
              entity: _vm.subscription,
              title: _vm.$t("log-links.subscription"),
            },
          }),
          _c(
            "modal",
            { attrs: { open: _vm.modalOpenned } },
            [
              _c("template", { slot: "content" }, [
                _c(
                  "div",
                  {
                    staticClass: "emd-container _highlight_header _footer_end",
                  },
                  [
                    _c("div", { staticClass: "emd-container__header" }, [
                      _c(
                        "h2",
                        {
                          staticClass:
                            "emd-text _size_section _color_secondary",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("subscription.info.modal.title")) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "emd-btn _type_link jsModalClose",
                          attrs: { type: "button" },
                          on: { click: _vm.closeModal },
                        },
                        [
                          _c("i", {
                            staticClass: "uil uil-times",
                            attrs: { transform: "width-11" },
                          }),
                        ]
                      ),
                    ]),
                    _c(
                      "form",
                      {
                        attrs: {
                          name: "cancelSubscription",
                          novalidate: "true",
                        },
                        on: { submit: _vm.cancelSubscription },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "emd-container__content" },
                          [
                            _vm.showAlert
                              ? _c(
                                  "emd-alert",
                                  {
                                    attrs: {
                                      variant: _vm.formError
                                        ? "danger"
                                        : "success",
                                      title: _vm.formError
                                        ? _vm.$t(
                                            "account.settings.alert.error-title"
                                          )
                                        : _vm.$t(
                                            "account.settings.alert.success-title"
                                          ),
                                    },
                                    on: {
                                      cancel: function ($event) {
                                        _vm.showAlert = false
                                      },
                                    },
                                  },
                                  [
                                    _c("template", { slot: "content" }, [
                                      _vm.formError
                                        ? _c(
                                            "div",
                                            _vm._l(
                                              _vm.errors,
                                              function (error, index) {
                                                return _c("p", { key: index }, [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(error.message) +
                                                      " "
                                                  ),
                                                ])
                                              }
                                            ),
                                            0
                                          )
                                        : _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "account.settings.saved-success"
                                                )
                                              )
                                            ),
                                          ]),
                                    ]),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _c("div", { staticClass: "emd-panel" }, [
                              _c(
                                "h2",
                                { staticClass: "emd-text _size_section" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "subscription.info.modal.cancel-detail"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "emd-panel" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "emd-panel__section" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "emd-form-group" },
                                      [
                                        _c("jade-checkbox", {
                                          attrs: {
                                            id: "cancelInvoices",
                                            value: _vm.cancelInvoices,
                                            label: _vm.$t(
                                              "subscription.info.modal.cancel-invoices"
                                            ),
                                          },
                                          on: {
                                            "update:value": function ($event) {
                                              _vm.cancelInvoices = $event
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _c("password-confirmation", {
                                  attrs: { label: null },
                                  model: {
                                    value: _vm.password,
                                    callback: function ($$v) {
                                      _vm.password = $$v
                                    },
                                    expression: "password",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "emd-container__footer" }, [
                          _c(
                            "button",
                            {
                              staticClass: "emd-btn _color_primary _type_text",
                              attrs: { type: "button" },
                              on: { click: _vm.closeModal },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "subscription.info.modal.button-cancel"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "emd-btn _color_primary",
                              attrs: {
                                type: "submit",
                                disabled: !_vm.password,
                              },
                            },
                            [
                              _vm.cancelLoading
                                ? _c("emd-loader", { attrs: { type: "" } })
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "subscription.info.modal.button-ok"
                                        )
                                      )
                                    ),
                                  ]),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
            ],
            2
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }